var map = {
	"./AGCasino.png": "6243",
	"./AGSlot.png": "8f58",
	"./ALLBET.png": "0297",
	"./AMBPoker.png": "8234",
	"./AMBSlot.png": "fae3",
	"./AMBSportbook.png": "4880",
	"./AdvantPlay.png": "c69f",
	"./AmebaEntertainment.png": "cd39",
	"./Askmebet.png": "34cf",
	"./Biggaming.png": "a608",
	"./Bolebit.png": "3e31",
	"./BoomingGames.png": "f1eb",
	"./CQ9.png": "94f4",
	"./CreativeGaming.png": "8146",
	"./DragonGaming.png": "873e",
	"./DragoonSoft.png": "214a",
	"./EVOPLAY.png": "61e5",
	"./Evolution.png": "2c88",
	"./FGG.png": "da52",
	"./FastGames.png": "aac5",
	"./Funkygame.png": "9078",
	"./GamingSoftSlot.png": "cf4c",
	"./HPLottery2D3D.png": "0274",
	"./Habanero.png": "8595",
	"./Hacksaw.png": "966a",
	"./Hotgraph.png": "a065",
	"./Jili.png": "6288",
	"./Jili2.png": "afa2",
	"./Joker.png": "7b1d",
	"./Joker1.png": "37e3",
	"./JustDoTheBest.png": "bde9",
	"./Kingmaker.png": "4f0f",
	"./Kingmaker2.png": "221f",
	"./Live22.png": "0be9",
	"./MCLotto.png": "5bce",
	"./Mannaplay.png": "eb44",
	"./MegaEntertainment.png": "dceb",
	"./MicroGaming.png": "90fe",
	"./Mimi.png": "9a33",
	"./Netent.png": "891f",
	"./Nextspin.png": "a3dc",
	"./NinjaSlot.png": "403b",
	"./NolimitCity.png": "d6c2",
	"./PG.png": "68e4",
	"./PGSlot.png": "4c5d8",
	"./PGSoft.png": "4042",
	"./PlayNgo.png": "6e14",
	"./PragmaticPlay.png": "27b7",
	"./PragmaticPlay2.png": "c9e0",
	"./PragmaticSlot.png": "da5d",
	"./PrettyGaming.png": "d5d9",
	"./QuickSpin.png": "0656",
	"./RedTiger.png": "2326",
	"./RelaxGaming.png": "665c",
	"./RelaxGaming2.png": "6f28",
	"./SAGaming.png": "571f",
	"./SGgaming.png": "d284",
	"./SboBet.png": "936d",
	"./SexyGaming.png": "2bd3",
	"./SimplePlay.png": "2b57",
	"./Spinix.png": "cd15",
	"./Sport688.png": "2b38",
	"./UPG.png": "e034",
	"./WMCasino.png": "5930",
	"./WMSlot.png": "1512",
	"./Yggdrasil.png": "7536",
	"./unuse/EVOPLAY.png": "fb25",
	"./unuse/PlayNgo.png": "258a",
	"./unuse/RelaxGaming.png": "2be1",
	"./unuse/SimplePlay.png": "d320",
	"./vivo.png": "4a56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "930c";